import Regex from "src/Utils/Regex";
import { ColumnType, TableColumnEnumType } from "../..";
import DateFormater from "src/Utils/DateFormater";
import './table_cell.scss';
import React, { ElementType } from "react";

interface ITableCell {
	column?: ColumnType;
	link: string;
	children?: React.ReactNode;
	data?: any;
	value?: any;
	width?: number;
	isExpand?: boolean;
};

/** Вспомогательный метод для поиска элемента перечисления по значению */
const onFindItem = ( item: TableColumnEnumType|string, value: any ): boolean => {
	if ( typeof item === "string" ) {
		return item === value.toString();
	}
	return item.id === value.toString();
};

/** Рендер Ячейки таблицы с данными  */
const TableCell: React.FC<ITableCell> = ( { column, link, data, children, value, width = 100, isExpand = false} ) => {

	const renderEnum = ( column: ColumnType ) => {
		let val;
		if ( !column.enums || !value )
			val = '-';
		else if ( !!column.enums ) {
			const item = column.enums.find( ei => onFindItem(ei, value) );
			if ( !item ) 
				val = "-";
			else 
				val = typeof item === "string" ? item : item.title;
		}	
		return <span title={val} >{val}</span>;
	};

	const renderContent = () => {
		let val: string = value;
		if ( !column ) {
			if ( !!value && Regex.ISO_8601_FULL.test(value) ) {
				val = DateFormater.toShortString(value);
				return <span title={val}>{val}</span>;
			}
			else
				return <span title={val}>{val}</span>;
		}
		else if ( !!column.cellRender )
			return column.cellRender(isExpand, data);
		else {
			switch ( column.type?.toLowerCase() ) {

				case "datetime":
				case "date": {
					if ( !Regex.ISO_8601_FULL.test(value) ) 
						val = value;
					else
						val = DateFormater.toShortString(value);
					return <span title={val}>{val}</span>;
				}
				case "enum": 
					return renderEnum(column);

				case "bool": {
					val = !!value ? 'Да' : 'Нет';
					return <span title={val}>{val}</span>;	
				}

				default: {
					val = data[column.id];
					return <span title={val}>{val}</span>;
				}
			}
		}	
	};

	/** Отменим для ссылки любые действия кроме щелчка ср. кнопки мыши */
	const onClickHandler = (e: React.MouseEvent<HTMLLinkElement, MouseEvent>) => {
		e.preventDefault();
		e.stopPropagation();
	};

	const props: any = { className: "rdc_table__cell", style: { width } };
	const Tag: ElementType = !!link ? "a" : "div";
	if ( !!link ) {
		props.href = link;
		props.draggable = false;
		props.onClick = onClickHandler;
	}

	return (
		<Tag {...props}> 
			{ (!column || !column.cellRender) && <span className="rdc_table__cell-icon" /> }
			<div className="rdc_table__cell-content">
				{ renderContent() }
				{ !!children && children }
			</div>
		</Tag>
	);
};

export default TableCell;
